import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './PengenaanPajak.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

var _baseId = "mod-table-pengenaan-pajak"

const PengenaanPajakTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
  }

  return (
    <>
    <TableWrapper
      baseId={_baseId}
      title={t.translate('modules.pengenaanPajak.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="nama"
      columns={[
        {
          label: 'Akumulasi',
          searchable: true,
          key: 'akumulasi',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.akumulasi)
        },{
          label: 'Domisili Pembeli',
          searchable: true,
          key: 'domisiliPembeli',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.domisiliPembeli)
        },{
          label: 'Domisili Penjual',
          searchable: true,
          key: 'domisiliPenjual',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.domisiliPenjual)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        },{
          label: 'Kode Objek Pajak ID',
          searchable: true,
          key: 'kodeObjekPajakId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kodeObjekPajakId)
        },{
          label: 'Tarif ID',
          searchable: true,
          key: 'tarifId',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarifId)
        },{
          label: 'Nilai Akumulasi Minimal',
          searchable: true,
          key: 'nilaiAkumulasiMaksimal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nilaiAkumulasiMaksimal)
        },{
          label: 'Nilai Transaksi Minimal',
          searchable: true,
          key: 'nilaiTransaksiMinimal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nilaiTransaksiMinimal)
        },{
          label: 'Nilai Transaksi Maksimal',
          searchable: true,
          key: 'nilaiTransaksiMaksimal',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nilaiTransaksiMaksimal)
        },{
          label: 'Pembayar Pajak',
          searchable: true,
          key: 'pembayarPajak',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.pembayarPajak)
        },{
          label: 'Pemungut Pajak',
          searchable: true,
          key: 'pemungutPajak',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.pemungutPajak)
        },{
          label: 'Status',
          searchable: true,
          key: 'status',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.status)
        },{
          label: 'Tipe Pembeli',
          searchable: true,
          key: 'tipePembeli',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tipePembeli)
        },{
          label: 'Tipe Penjual',
          searchable: true,
          key: 'tipePenjual',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tipePenjual)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/pengenaan-pajak/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/pengenaan-pajak/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default PengenaanPajakTable
